<template>
  <nav class="lang flex py-9 px-6 md:px-9 pb-6">
    <ul class="flex">
      <li
        v-for="(lang, i) in langs"
        :key="`Lang${i}`"
      >
        <label
          class="md:text-lg text-gray-700 mx-1 uppercase cursor-pointer"
          :class="{'active': currentLang === lang }"
        ><input
          v-model="$i18n.locale"
          class="hidden"
          type="radio"
          :value="lang"
        >{{ lang }}</label>
        <span
          v-if="langs.length !== (i+1)"
          class="text-gray-200 align-top"
        >|</span>
      </li>
    </ul>
  </nav>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'LocaleChanger',
  data() {
    return {
      langs: ['pl', 'en'],
    };
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
  },
  watch: {
    currentLang(newLang) {
      this.changeLang({ lang: newLang });
    },
  },
  methods: {
    ...mapActions('pref', ['changeLang']),
  },
};
</script>
<style lang="scss">
  nav.lang {
    .active {
      @apply text-primary font-bold;
    }
  }
</style>
